import * as React from 'react';

import { Drawer } from '@/components/ui';
import { AVAILABLE_GRADES } from '@/features/user-notifications/utils/constants';

import { useEnrollToSchoolCurriculum } from '../../api/queries';
import { EnrollmentDrawerContent } from '../shared';

interface SchoolCurriculumDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const SCHOOL_CURRICULUM_DESCRIPTION =
  "Enjoy free access to a tailored course with recorded videos, covering your current and next year's school curriculum. Elevate your learning experience now!";

export const SchoolCurriculumDrawer: React.FC<SchoolCurriculumDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      contentClassName="bg-magical-moonlight-white"
      childClass="!max-w-full"
      topOffset="top-[25%]"
      closeButtonPosition={{ top: 'top-[20%]', right: 'right-6' }}
      innerContentClassName="p-2 md:p-3"
      role="dialog"
      aria-modal="true"
    >
      <EnrollmentDrawerContent
        description={SCHOOL_CURRICULUM_DESCRIPTION}
        availableGrades={AVAILABLE_GRADES}
        useEnrollmentHook={useEnrollToSchoolCurriculum}
        onClose={onClose}
        enrollmentType="school-curriculum"
      />
    </Drawer>
  );
};
